














import { Component, Vue } from "vue-property-decorator";
import { getCache, getArea, getActivityListNew } from "jhm_api_ts";
import { State } from "vuex-class";
import { hiddenLoading, showLoading } from "@/utils/loading";
import TechnicalSupport from "./components/TechnicalSupport.vue";

@Component({
  components: {
    TechnicalSupport,
  },
})
export default class Home extends Vue {
  @State("pid") public pid!: string;
  @State("aid") public aid!: string;

  area: any = {};
  activityList: any = [];
  async mounted() {
    this.checkRegionInfo();

    showLoading();

    this.activityList = await this.initActivityList();
    this.area = await this.initArea();

    hiddenLoading();

    if (this.area.activity_tpis) {
      // 活动提示文案-存在即显示(默认放到最后执行)
      this.$dialog.alert({
        title: "温馨提示",
        message: this.area.activity_tpis,
      });
    }
  }
  /**
   * @Description: 是否有地区机构信息有就保存下单时携带如果没有去跳转补充地区信息
   */
  checkRegionInfo() {
    let { region, institution } = this.$route.query;

    if (region) {
      sessionStorage.setItem(
        "region_institution",
        JSON.stringify({ region, institution })
      );
    }
    // else if (!region && !sessionStorage.getItem("region_institution")) {
    //   this.$router.push("/authorInfoUser");
    // }
  }

  /**
   * @return {array} 活动列表集合
   * @Description: 初始化活动信息列表
   */
  async initActivityList() {
    let res = await getActivityListNew({ pid: this.pid });
    return res.data[594].activity_list;
  }

  async initArea() {
    let { info: area }: any = await getCache(getArea, { id: this.aid });
    return area;
  }

  toPage(val: any) {
    if (val.url) {
      window.location.href = `${val.url}`;
    } else {
      this.$toast.fail("敬请期待");
    }
  }
}
